export type EventSoundCategory =
  | "1yatta"
  | "asahayai_yatta"
  | "no_complete"
  | "perfect"
  | "seihoukei";

export const EVENT_SOUNDS: Record<EventSoundCategory, string[]> = {
  "1yatta": [
    "/sounds/events/1yatta/1.wav",
    "/sounds/events/1yatta/2.wav",
    "/sounds/events/1yatta/3.wav",
    "/sounds/events/1yatta/4.wav",
    "/sounds/events/1yatta/5.wav",
    "/sounds/events/1yatta/6.wav",
    "/sounds/events/1yatta/7.wav",
    "/sounds/events/1yatta/8.wav",
    "/sounds/events/1yatta/9.wav",
    "/sounds/events/1yatta/10.wav",
    "/sounds/events/1yatta/11.wav",
    "/sounds/events/1yatta/12.wav",
    "/sounds/events/1yatta/13.wav",
    "/sounds/events/1yatta/14.wav",
    "/sounds/events/1yatta/15.wav"
  ],
  asahayai_yatta: ["/sounds/events/asahayai_yatta/1.wav"],
  no_complete: ["/sounds/events/no_complete/1.wav"],
  perfect: [
    "/sounds/events/perfect/1.wav",
    "/sounds/events/perfect/2.wav",
    "/sounds/events/perfect/3.wav",
    "/sounds/events/perfect/4.wav",
    "/sounds/events/perfect/5.wav"
  ],
  seihoukei: ["/sounds/events/seihoukei/1.wav"]
};
